export enum EngineTriggerTypeEnum {
    Unknown,
    Init,
    NO_DATA,
    Scenario,
    Scenario_LowPriority,
    Timer,
    R210,
    R2110,
    R2210,
    Manual,
    MARZ,
    MQ_Scenario,
    MQ_Manual,
    MQ_Timer,
    MQ_Action,
    MQ_Scenario_LowPriority,
    Timeout_no_MQ_data,
    DI_AUTO,
    DI_Scenario,
    DI_Timer,
    DI_Manual,
    DI_Scenario_LowPriority,
    Timeout_no_DI_data,
    // MARZ 3.12.5 — Werte 23/24 wie in APISharedLib.TriggerType (nur anhaengen, nie umnummerieren)
    LongitudinalAdjustment,
    TransverseAdjustment
}

export function getEngineTriggerString(engineTriggerType: EngineTriggerTypeEnum | undefined): string {
    switch (engineTriggerType) {
        case EngineTriggerTypeEnum.Unknown:
            return 'Unbekannt';
        case EngineTriggerTypeEnum.Init:
            return 'Neu';
        case EngineTriggerTypeEnum.NO_DATA:
            return 'Keine Daten';
        case EngineTriggerTypeEnum.Scenario:
            return 'Sonderprogramm';
        case EngineTriggerTypeEnum.Scenario_LowPriority:
            return 'Sonderprogramm niedr.Prio.';
        case EngineTriggerTypeEnum.Timer:
            return 'Zeitschaltuhr';
        case EngineTriggerTypeEnum.R210:
            return 'Regel R210';
        case EngineTriggerTypeEnum.R2110:
            return 'Regel R2110';
        case EngineTriggerTypeEnum.R2210:
            return 'Regel R2210';
        case EngineTriggerTypeEnum.Manual:
            return 'AQ-Manuell';
        case EngineTriggerTypeEnum.MARZ:
            return 'MARZ';
        case EngineTriggerTypeEnum.MQ_Scenario:
            return 'MQ-Sonderprogramm';
        case EngineTriggerTypeEnum.MQ_Manual:
            return 'MQ-Manuell';
        case EngineTriggerTypeEnum.MQ_Timer:
            return 'MQ-Zeitschaltuhr';
        case EngineTriggerTypeEnum.MQ_Action:
            return 'MQ-Sonderfall';
        case EngineTriggerTypeEnum.MQ_Scenario_LowPriority:
            return 'MQ-Sonderprogramm niedr.Prio.';
        case EngineTriggerTypeEnum.Timeout_no_MQ_data:
            return 'Timeout MQ';
        case EngineTriggerTypeEnum.DI_AUTO:
            return 'DI-Auto';
        case EngineTriggerTypeEnum.DI_Scenario:
            return 'DI-Sonderprogramm';
        case EngineTriggerTypeEnum.DI_Timer:
            return 'DI-Zeitschaltuhr';
        case EngineTriggerTypeEnum.DI_Manual:
            return 'DI-Manuell';
        case EngineTriggerTypeEnum.DI_Scenario_LowPriority:
            return 'DI-Sonderprogramm niedr.Prio.';
        case EngineTriggerTypeEnum.Timeout_no_DI_data:
            return 'Timeout DI';
        case EngineTriggerTypeEnum.LongitudinalAdjustment:
            return 'Längsabgleich';
        case EngineTriggerTypeEnum.TransverseAdjustment:
            return 'Querabgleich';
        default:
            return '';
    }
}
